import http from "./httpService";
import {Api} from "../../helpers/api";
import {AxiosResponse} from "axios";

export class DownloadService {
    public static async download(apiUrl: string, mediaType: "application/xls" | "application/csv", params: string): Promise<AxiosResponse> {
        const url = `${Api.getUrl(apiUrl)}/download`;
        return http.get<string>(`${Api.addParams(url, params)}`, {
            headers: {
                accept: mediaType
            },
            responseType: "blob"
        });
    }

    public static async downloadSummaryReport(apiUrl: string, mediaType: "application/xls" | "application/csv", params: string): Promise<AxiosResponse> {
        const url = `${Api.getUrl(apiUrl)}/download-summary`;
        return http.get<string>(`${Api.addParams(url, params)}`, {
            headers: {
                accept: mediaType
            },
            responseType: "blob"
        });
    }
}
